import loadingGif from '/src/assets/loadingGif.gif';
import booksGif from '/src/assets/booksGif.gif';
import historyBlueBotIcon from '/src/assets/historyBlueBotIcon.svg';
import historyRedBotIcon from '/src/assets/historyRedBotIcon.svg';
import {
  CHATBOT_MODE_CHATBOT,
 } from '../utils/constants.js';
import clsx from 'clsx';

export default function LoadingMessageChatBot({isLoadingState, modeChatbot, navigationStateChatbot}){

    return <>
    {isLoadingState &&
        <div className='bot-utn-styled-message-row bot-utn-first-message bot-utn-last-message'>
            {modeChatbot ?
            <div className='bot-utn-from-icon-container'>
                <img src={historyBlueBotIcon} alt='logo alert'/>
            </div>
            :
            <div className='bot-utn-from-icon-container'>
                <img src={historyRedBotIcon} alt='logo alert'/>
            </div>
            }
            <div className={clsx({
                    'bot-utn-container-text-bot': modeChatbot === CHATBOT_MODE_CHATBOT,
                    'bot-utn-recommender-container-loading-bot': modeChatbot !== CHATBOT_MODE_CHATBOT
                })}
            >
                {navigationStateChatbot === 0 ?
                <img src={booksGif} alt="Packman gift de carga"/>
                :
                <img src={loadingGif} alt="Packman gift de carga"/>
            }
            </div>
        </div>}
    </>
}